import { Remove } from "@mui/icons-material";

const { Box } = require("@mui/material");

function CollapseIcon() {
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #111",
      }}
    >
      <Remove sx={{ fontSize: 9 }} />
    </Box>
  );
}

export default CollapseIcon;
